export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_ADMIN = 'LOGIN_ADMIN';
export const RESET_LOGIN_DATA = 'RESET_LOGIN_DATA';
